export default __webpack_public_path__ + "static/media/matti_l.25dd1777.jpg";